import { secondary } from '../App/theme';
import { Card, Title, Description, CardContent, CheckboxContent } from './style';
import Checkbox from "react-custom-checkbox";
import CheckIcon from 'react-feather/dist/icons/check';

export default function CheckboxCard({ value, name, title, description, handleChange, style, isDisabled }) {
  return (
    <Card style={style && style.root ? { ...style.root } : null}>
      <CardContent>
        <CheckboxContent>
          <Checkbox checked={value} onChange={(value) => handleChange(value, name)}
            borderColor={secondary.main}
            disabled={isDisabled}
            style={{ margin: '10px', backgroundColor: value && secondary.main, opacity: isDisabled ? '.3' : '1'  }}
            icon={<CheckIcon color={'#FFF'} size={16} />}
            size={14} />
        </CheckboxContent>
        <Title style={style && style.title ? { ...style.title } : null}>{title}</Title>
      </CardContent>
      {description ? <Description>
        {description}
      </Description>
        : null}
    </Card>
  )
}